import { ResultsState } from 'enums'

import { isDataAccessRequest } from 'modules/requests/utils'
import { DataAccessRequestReviewSubStatus, DataAccessRequestStatus } from 'services/data-access-requests/enums'
import { useGetDataAccessRequestVerification } from 'services/data-access-requests/hooks/useGetDataAccessRequestVerification'
import type { Result } from 'services/results/types'

interface UseDataAccessRequestRelatedSectionParams {
  resultId: string
  result: Result | undefined
}

export const useDataAccessRequestRelatedSection = ({ resultId, result }: UseDataAccessRequestRelatedSectionParams) => {
  const isDataAccessRequestResult = result !== undefined && isDataAccessRequest(result)
  const isApproved = isDataAccessRequestResult && result.status === ResultsState.Complete

  const verificationQuery = useGetDataAccessRequestVerification({
    requestId: resultId,
    options: {
      enabled: isDataAccessRequestResult && isApproved
    }
  })

  const verificationDetail = verificationQuery.data
  const reviewSubStatus =
    verificationDetail?.reviewSubStatus ??
    (result?.reviewSubStatus === DataAccessRequestReviewSubStatus.AdditionalInformationRequired
      ? DataAccessRequestReviewSubStatus.AdditionalInformationRequired
      : undefined)

  return {
    studyId: verificationDetail?.studyId,
    requestStatus: verificationDetail?.status ?? DataAccessRequestStatus.PendingVerification,
    reviewSubStatus,
    dataAccessRequestDetail: verificationDetail?.dataAccessRequestDetail,
    sharing: verificationDetail?.sharing
  }
}
